module.exports = __webpack_public_path__ + "static/media/netstorage/fonts/mako_extra_bold.woff";